import { v3 } from '@adobe/edex/frontend/api/v3';
import { AxiosRequestConfig } from 'axios';

const baseURL = '/favorite';

export function paginate(config?: AxiosRequestConfig) {
  return v3.get(`${baseURL}`, config);
}

export function create(entityID, entityType) {
  return v3.post(`${baseURL}`, {
    entityID,
    entityType,
  });
}

export function remove(entityID, entityType) {
  return v3.delete(`${baseURL}/${entityType}/${entityID}`);
}
